// extracted by mini-css-extract-plugin
export default {"default-badge":"ML0mU"};